export const statusSteps = ['PEN', 'ACT', 'ARC']
export const statusObject: {
  [key: string]: { label: string; caption: string }
} = {
  PEN: {
    label: 'Pending',
    caption: 'Initial configuration stage',
  },
  ACT: {
    label: 'Active',
    caption: 'Ready for data collection',
  },
  ARC: {
    label: 'Archived',
    caption: 'Data collection disabled',
  },
}
